import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import "core-js/modules/es.array.map.js";
import { defineComponent, reactive, ref, toRefs } from "vue";
import { brightenKeyword } from "@/hooks/lightKeyword";
import Loading from "@/baseui/loading/loading.vue";
import { useState } from "@/hooks/mapGet/index.js";
import { useStore } from "vuex";
export default defineComponent({
  name: "listDetail",
  props: {
    musicList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    inputValue: {
      type: String,
      default: ""
    }
  },
  setup: function setup(props) {
    var state = useState("player", ["currentId"]);
    var store = useStore();

    var _toRefs = toRefs(props),
        musicList = _toRefs.musicList;
    /* 标题数据 */


    var listTitle = reactive([{
      class: "song-name",
      title: "音乐标题"
    }, {
      class: "songer",
      title: "歌手"
    }, {
      class: "album",
      title: "专辑"
    }, {
      class: "duration",
      title: "时长"
    }]);
    var isActive = ref(0);
    /* 歌曲点击事件,并点击播放 */

    var songItemClick = function songItemClick(id) {
      isActive.value = id; //存储当前列表所有歌曲id为数组

      var songIds = musicList.value.map(function (song) {
        return song.id;
      }); //播放当前歌曲

      store.dispatch("player/setSongListByIds", {
        ids: songIds,
        currentId: id
      });
    };
    /* 关键字高亮 */


    var lightKeyword = brightenKeyword;
    return _objectSpread(_objectSpread({}, state), {}, {
      isActive: isActive,
      listTitle: listTitle,
      songItemClick: songItemClick,
      lightKeyword: lightKeyword
    });
  },
  components: {
    Loading: Loading
  }
});